export default __webpack_public_path__ + "static/media/logo.d75d7223.png";